<template>
  <div class="new-rating-form">
    <div v-if="!show_form">
      <p class="app-modal-alert app-modal-alert--success">
        Vielen Dank für Ihre Bewertung — wir werden sie in Kürze veröffentlichen.
      </p>
    </div>

    <form v-if="show_form" class="app-modal-form" @submit.prevent="submitForm">
      <div class="app-modal-form__section">
        <p class="app-modal-form__section-title">Ihre Bewertung</p>
        <Rating
          class="stars"
          size="5"
          max="5"
          :value="rating_value"
          selectable
          @onSetvalue="setRatingValue"
        />
      </div>

      <div class="app-modal-form__section">
        <div class="row">
          <div class="col-sm-12 form-group">
            <label for="rating-name">Ihr Name *</label>
            <input
              id="rating-name"
              type="text"
              class="form-control"
              placeholder="Ihr Name"
              v-model="rating_name"
              required
            />
          </div>

          <div class="col-sm-12 form-group">
            <label for="rating-comment">Ihr Kommentar *</label>
            <textarea
              id="rating-comment"
              class="form-control"
              placeholder="Ihre Erfahrung mit der Ferienwohnung"
              v-model="rating_comment"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="app-modal-form__section">
        <div class="app-modal-form__actions">
          <FriendlyCaptchaField
            :key="captchaKey"
            @validated="captchaValid = $event"
            @error="onCaptchaError"
          />
          <button
            type="submit"
            :disabled="!canSubmit"
            class="button light"
            id="submit_btn_rating"
          >
            Absenden
          </button>
        </div>
      </div>
    </form>

    <div v-if="show_error_message" class="app-modal-alert app-modal-alert--error">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { useApi } from '../../composables/useApi.js'
import { useCookieConsent } from '../../composables/useCookieConsent.js'
import Rating from './Rating.vue'
import FriendlyCaptchaField from './FriendlyCaptchaField.vue'

const DEFAULT_ERROR_MESSAGE =
  'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'

export default {
  props: {
    appartment_id: [Number, String],
  },
  components: {
    Rating,
    FriendlyCaptchaField,
  },
  setup() {
    const api = useApi()
    const { externalAllowed } = useCookieConsent()

    return {
      api,
      externalAllowed,
    }
  },
  data() {
    return {
      show_form: true,
      captchaValid: false,
      captchaKey: 0,
      rating_value: 5,
      rating_name: '',
      rating_comment: '',
      show_error_message: false,
      errorMessage: DEFAULT_ERROR_MESSAGE,
    }
  },
  computed: {
    canSubmit() {
      return (
        this.rating_name.trim().length > 2 &&
        this.rating_comment.trim().length > 5 &&
        this.captchaValid &&
        this.externalAllowed
      )
    },
  },
  methods: {
    setRatingValue(value) {
      this.rating_value = value
    },
    resetCaptcha() {
      this.captchaValid = false
      this.captchaKey += 1
    },
    onCaptchaError(message) {
      this.errorMessage =
        message ||
        'Die Sicherheitsprüfung konnte nicht geladen werden. Bitte Seite neu laden.'
      this.show_error_message = true
    },
    async submitForm() {
      if (!this.canSubmit) return

      this.show_error_message = false
      this.errorMessage = DEFAULT_ERROR_MESSAGE
      this.show_form = false

      try {
        const ratingData = {
          name: this.rating_name,
          comment: this.rating_comment,
          rating: this.rating_value,
          vacation_rental_id: this.appartment_id,
        }

        await this.api.createRating(ratingData)
        this.resetCaptcha()
      } catch (error) {
        console.error('Fehler beim Erstellen der Bewertung:', error)
        this.show_form = true
        this.errorMessage = DEFAULT_ERROR_MESSAGE
        this.show_error_message = true
        this.resetCaptcha()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.new-rating-form {
  .stars {
    display: flex;
    justify-content: center;
    margin: 4px 0 0;
  }

  .app-modal-form__actions .button {
    margin-top: 12px;
  }
}
</style>
